export function getNews (state) {
  return state.news
}



// WEBPACK FOOTER //
// ./src/vuex/forgamers/getters.js